import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import login from './modules/login'
import user from './modules/user'
import patient from './modules/patient'
import online from './modules/onlineUser'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    login,
    user,
    patient,
    online
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js